import "./PercentageBar.css";
const PercentageBar = ({
  percentage,
  correctAnswer,
  correctAnswerValue,
  option,
  highlightBarColor = "gold",
  gameType = 2,
  optionTextColor = "white",
  isActive,
  index,
  settings,
}) => {
  const formatPercentage = (value) => {
    if (Math.floor(value) === value) {
      return value; // return as is if no decimal places
    }

    // Round up to 1 decimal place and return
    const oneDecimalPlace = Math.round(value * 10) / 10;

    if (Math.floor(oneDecimalPlace) === oneDecimalPlace) {
      return oneDecimalPlace;
    }

    // Round up to 2 decimal places and return
    return Math.round(value * 100) / 100;
  };
  const roundedPercentage = formatPercentage(percentage);

  const getAvatarPosition = (position) => {
    if (position === "left") {
      return {
        right: `calc(100% + ${settings.mediaItemX}px)`,
        top: `calc(50% - ${settings?.mediaItemY || 0}px)`,
      };
    } else if (position === "right") {
      return {
        left: `calc(100% + ${settings.mediaItemX}px)`,
        top: `calc(50% - ${settings?.mediaItemY || 0}px)`,
      };
    } else if (position === "top") {
      return {
        bottom: `calc(100% + ${settings?.mediaItemY || 0}px)`,
        left: `calc(50% - ${settings.mediaItemX}px)`,
      };
    } else if (position === "bottom") {
      return {
        top: `calc(100% + ${settings?.mediaItemY || 0}px)`,
        left: `calc(50% - ${settings.mediaItemX}px)`,
      };
    }
  };

  function getAvatarStyle() {
    const border = {
      border: `${settings.borderWidth}px solid ${settings.borderColor}`,
      background: "transparent",
      borderRadius: settings.mediaBorderRadius
        ? `${settings.mediaBorderRadius}%`
        : "50%",
    };
    const scale = { scale: `${settings.mediaCardScale / 100}` };
    let transform = {
      transform: `translateY(-${50 / (settings.mediaCardScale / 100)}%)`,
    };
    let position = {};
    const transformFactor = settings.mediaCardScale / 100;
    if (settings.alternatePosition) {
      if (settings.position === "top" || settings.position === "bottom") {
        transform = {
          transform: `translateX(-${50 / transformFactor}%)`,
        };
        position = getAvatarPosition(index % 2 === 0 ? "top" : "bottom");
      } else {
        position = getAvatarPosition(index % 2 === 0 ? "left" : "right");
      }
    } else {
      position = getAvatarPosition(settings.position);

      if (settings.position === "top" || settings.position === "bottom") {
        transform = {
          transform: `translateX(-${50 / transformFactor}%)`,
        };
        position = getAvatarPosition(settings.position);
      }
    }
    return { ...position, ...border, ...scale, ...transform };
  }

  return (
    <div className={`progressBarWrapper ${index % 2 === 0 ? "left" : "right"}`}>
      {option.optionImage && (
        <img
          className="avatar"
          src={option.optionImage}
          alt={option.optionText}
          style={getAvatarStyle(index)}
        />
      )}

      <div
        className="progressBarContainer"
        style={{
          borderRadius: settings.borderRadius
            ? `${settings.borderRadius}px`
            : "5rem",
        }}
      >
        <div className="optionContent" style={{ color: optionTextColor }}>
          <div>{option.optionText}</div>

          <div
            className="percentageContainer"
            style={{
              borderRadius: settings.borderRadius
                ? `${settings.borderRadius}px`
                : "5rem",
            }}
          >
            <span className="percentage">{`${roundedPercentage}%`}</span>
          </div>
        </div>
        <div
          style={{
            height: "100%",
            width: `${percentage}%`,
            position: "absolute",
            inset: 0,
            backgroundColor: isActive
              ? highlightBarColor
              : correctAnswer || gameType === "2"
              ? highlightBarColor
              : "#A3A4AA",
          }}
        ></div>
      </div>
    </div>
  );
};
export default PercentageBar;
